@use '../../styles/border' as border;
@use '../../styles/surface' as surface;
@use '../../styles/text' as text;
@use '../../styles/icon' as icon;
@use '../../styles/typography' as typography;

.root {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  border-radius: 8px;
  padding: 32px 24px;
}

.group {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.copy {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 280px;
}

.action {
  display: flex;
  align-items: center;
  gap: 8px;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: icon.$icon-secondary;
}

.transparent {
  background: transparent;
}

.background {
  background: surface.$surface-background;
}

.default {
  background: surface.$surface-default;
  border: border.$border-width solid border.$border-default;
}

.full {
  background: surface.$surface-full;
  border: border.$border-width solid border.$border-default;
}

.title {
  color: text.$text-primary;
}

.subtitle {
  color: text.$text-tertiary;
  text-wrap: pretty;
}

.sm {
  & {
    gap: 12px;
  }

  .icon svg {
    width: 24px;
    height: 24px;
  }

  .group {
    gap: 8px;
  }

  .copy {
    gap: 2px;
  }

  .title {
    @include typography.text-m-medium;
  }

  .subtitle {
    @include typography.text-s-regular;
  }
}

.lg {
  & {
    gap: 16px;
  }

  .icon svg {
    width: 28px;
    height: 28px;
  }

  .group {
    gap: 12px;
  }

  .copy {
    gap: 6px;
  }

  .title {
    @include typography.text-xl-medium;
  }

  .subtitle {
    @include typography.text-l-regular;
  }
}
